export default __webpack_public_path__ + "img/b8ba4f6bf3f5847769684599936bedc9.png";